export const selectContinueWatching = state => state.continueWatching;
